import React from "react";

const PALETTE = {
  CON: { bg: "#E8EFE9", fg: "#2F4F3E", border: "#D6E2D8", label: "CON", title: "Lux Construction" },
  DEV: { bg: "#FEF3E2", fg: "#B45309", border: "#F2DFB8", label: "DEV", title: "Lux Developments" }
};

export default function BrandBadge({ brand = "CON" }) {
  const p = PALETTE[brand] || PALETTE.CON;
  return (
    <span
      title={p.title}
      className="inline-flex items-center justify-center rounded font-mono"
      style={{
        background: p.bg,
        color: p.fg,
        border: `1px solid ${p.border}`,
        padding: "2px 6px",
        fontSize: 10,
        fontWeight: 600,
        letterSpacing: "0.04em"
      }}
    >
      {p.label}
    </span>
  );
}
